<template>
  <div class="new_ui_form">
    <form class="search-card" @submit.prevent="searchEvent">
      <div class="search-card-header" v-if="showCardHeader">
        <h1 class="search-card-title">Discover Culture in Your City</h1>
        <p class="search-card-subtitle lh-sm">Explore cultural events, businesses, artists, makers, organizations, restaurants, and experiences - all in one place.</p>
      </div>

      <div class="search-card-body">
        <!-- Search Events / Cultures field -->
        <div
          class="search-field-group"
          v-if="router.currentRoute.value.name != 'whatInTheCity'"
        >
          <label class="search-field-label">CULTURE ORGANIZATION OR EVENTS</label>
          <SearchFields
            :modelValue="searchQry"
            v-model="fieldValues.events"
            wrapper-classes="search-card-events-field"
            :address="address"
            :latLngToAddress="latLngToAddress"
            placeholder="Search culture, events, businesses, artists, organizations, restaurants…"
            iconImg="true"
            :is-required="false"
          />
        </div>

        <!-- Location field -->
        <div class="search-field-group">
          <label class="search-field-label">LOCATION</label>
          <div class="search-field-input position-relative">
            <img :src="elmapMarker" alt="Location" class="field-icon" />
            <GMapAutocomplete
              placeholder="Enter a city or ZIP code"
              @place_changed="setPlace"
              :value="latLngToAddress"
              @keyup="locationkeyup"
              :types="['(cities)']"
            />
            <i
              class="fa fa-times field-clear"
              v-if="latLngToAddress"
              v-on:click="clearaddress()"
            ></i>
            <div class="error" v-if="!address?.lat && latLngToAddress">
              Please Select Location Suggestion
            </div>
          </div>
        </div>

        <!-- Submit -->
        <button type="submit" class="search-card-btn primary-bg">
          <img :src="searchIcon" alt="" class="btn-icon" />
          Explore Culture
        </button>
      </div>
    </form>
    <a id="clearSearch" v-on:click="clear()"></a>
  </div>
</template>

<script setup>
import elmapMarker from "@/assets/g-img/elmap-marker.svg";
import searchIcon from "@/assets/g-img/search-w-icon.svg";
import SearchFields from "@/components/common/form/search-fields";
import { onMounted, reactive, ref, watch, watchEffect } from "vue";
import { useRoute, useRouter } from "vue-router";
import { ROUTES } from "@/utils/constants/routes";
import useReverseGeocoding from "@/composables/use-reverse-geocoding";
import { isUserLoggedIn } from "@/utils/helpers";

const router = useRouter();
let fieldValues = reactive({
  events: "",
});

const props = defineProps({
  showCardHeader: {
    type: Boolean,
    default: true,
  },
});

const isLoggedIn = ref(isUserLoggedIn());
const route = useRoute();

const searchQry = ref(
  route.query.q
    ? route.query.q
    : fieldValues?.events
    ? fieldValues?.events
    : "",
);

const address = ref({ lat: 0, lng: 0 });
const latLngToAddress = ref("");

const getCurrentPosition = () => {
  return new Promise((resolve, reject) => {
    navigator.geolocation.getCurrentPosition(resolve, reject);
  });
};

const setPlace = (place) => {
  address.value = {
    lat: place?.geometry?.location.lat(),
    lng: place?.geometry?.location.lng(),
  };

  localStorage.setItem("alat", address.value.lat);
  localStorage.setItem("alng", address.value.lng);
  localStorage.setItem("aplace", place?.name);
  console.log("SETPLL", place?.name);

  searchEvent();
};

watchEffect(async () => {
  if (address?.value && address?.value.lat) {
    let addressData = await useReverseGeocoding(
      address?.value?.lat,
      address?.value?.lng,
    );

    latLngToAddress.value = addressData?.data?.results
      ?.find((el) => el?.types?.find((innerEl) => innerEl === "locality"))
      .address_components.find((childEl) =>
        childEl?.types?.find((childTypeEl) => childTypeEl === "locality"),
      ).long_name;

    localStorage.setItem("aplace", latLngToAddress.value);
    console.log("WATCEFF", latLngToAddress.value);
  }
});

//Listening to route changes to check if user is still logged in
watch(
  () => route.path,
  async () => {
    isLoggedIn.value = isUserLoggedIn();
    if (route.path !== "/search") {
      await fetchUsersAddress();
    }
    if (
      localStorage.getItem("alat") === "" &&
      localStorage.getItem("alng") === ""
    ) {
      address.value = "";
      latLngToAddress.value = "";
    }
  },
);

watch(
  () => route.query,
  () => {
    searchQry.value = route.query.q ? route.query.q : "";
  },
);
onMounted(async () => {
  if (!localStorage.getItem("alat") && !localStorage.getItem("alng")) {
    if (route.query["lat"] && route.query["lng"]) {
      address.value = {
        lat: route.query["lat"],
        lng: route.query["lng"],
      };
    } else {
      const currentPosition = await getCurrentPosition();

      if (currentPosition) {
        address.value = {
          lat: currentPosition.coords?.latitude,
          lng: currentPosition.coords?.longitude,
        };
      }
    }
  }

  if (!localStorage.getItem("alat") && !localStorage.getItem("alng")) {
    localStorage.setItem("lat", address.value.lat);
    localStorage.setItem("lng", address.value.lng);
    localStorage.setItem("alat", address.value.lat);
    localStorage.setItem("alng", address.value.lng);
  }

  await fetchUsersAddress();

  if (
    localStorage.getItem("alat") != undefined &&
    localStorage.getItem("alng") != undefined
  ) {
    address.value = {
      lat: localStorage.getItem("alat"),
      lng: localStorage.getItem("alng"),
    };

    let addressData = await useReverseGeocoding(
      localStorage.getItem("alat"),
      localStorage.getItem("alng"),
    );

    latLngToAddress.value = addressData?.data?.results
      ?.find((el) => el?.types?.find((innerEl) => innerEl === "locality"))
      .address_components.find((childEl) =>
        childEl?.types?.find((childTypeEl) => childTypeEl === "locality"),
      ).long_name;
    localStorage.setItem("aplace", latLngToAddress.value);

    // alert(latLngToAddress.value)
  } else {
    if (route.query.lat && route.query.lng) {
      address.value = {
        lat: route.query.lat,
        lng: route.query.lng,
      };
      let addressData = await useReverseGeocoding(
        route.query.lat,
        route.query.lng,
      );

      latLngToAddress.value = addressData?.data?.results
        ?.find((el) => el?.types?.find((innerEl) => innerEl === "locality"))
        .address_components.find((childEl) =>
          childEl?.types?.find((childTypeEl) => childTypeEl === "locality"),
        ).long_name;
      localStorage.setItem("aplace", latLngToAddress.value);
    }
  }
});

const locationkeyup = (e) => {
  latLngToAddress.value = e.target.value;
  address.value = "";
  localStorage.setItem("alat", "");
  localStorage.setItem("alng", "");
  localStorage.setItem("aplace", "");
};

const clear = () => {
  latLngToAddress.value = "";
  address.value = "";
  fieldValues.events = "";
  searchQry.value = "";
  localStorage.setItem("alat", "");
  localStorage.setItem("alng", "");
  localStorage.setItem("aplace", "");
  searchEvent();
};

const clearaddress = () => {
  latLngToAddress.value = "";
  address.value = "";
  localStorage.setItem("alat", "");
  localStorage.setItem("alng", "");
  localStorage.setItem("aplace", "");
};

const searchEvent = () => {
  if (typeof window.gtag === 'function') {
    window.gtag('event', 'search_click', { location: 'search_form' });
  }
  let parms = {
    lat: latLngToAddress.value
      ? address?.value
        ? address?.value?.lat
        : ""
      : "",
    lng: latLngToAddress.value
      ? address?.value
        ? address?.value?.lng
        : ""
      : "",
    q: fieldValues?.events
      ? fieldValues?.events
      : route.query.q
      ? route.query.q
      : "",
  };
  if (!address?.value?.lat && latLngToAddress.value) return;
  router.push({ name: ROUTES.SEARCH, query: parms });
};
</script>

<style scoped>
/* Card container */
.search-card {
  background: #fff;
  border-radius: 16px;
  padding: 28px 24px 24px;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.12);
  width: 100%;
  max-width: 420px;
}

/* Header */
.search-card-header {
  margin-bottom: 20px;
}

.search-card-title {
  font-size: 22px;
  font-weight: 700;
  color: #111;
  margin-bottom: 6px;
  line-height: 1.3;
}

.search-card-subtitle {
  font-size: 13px;
  color: #666;
  margin-bottom: 10px;
}

/* Body: stacked fields + button */
.search-card-body {
  display: flex;
  flex-direction: column;
  gap: 14px;
}

/* Single field group */
.search-field-group {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.search-field-label {
  font-size: 10px;
  font-weight: 600;
  letter-spacing: 0.08em;
  color: #888;
  text-transform: uppercase;
}

/* Input row */
.search-field-input {
  display: flex;
  align-items: center;
  border: 1px solid #e2e2e2;
  border-radius: 10px;
  padding: 0 14px;
  height: 52px;
  background: #fff;
  gap: 10px;
}

.search-field-input :deep(input) {
  border: none !important;
  outline: none !important;
  flex: 1;
  font-size: 14px;
  color: #333;
  background: transparent;
  height: 100%;
  padding: 0;
}

.search-field-input :deep(input::placeholder) {
  color: #aaa;
}

.field-icon {
  width: 18px;
  height: 18px;
  flex-shrink: 0;
  opacity: 0.6;
}

.field-clear {
  cursor: pointer;
  color: #aaa;
  font-size: 13px;
  flex-shrink: 0;
}

.field-clear:hover {
  color: #666;
}

.error {
  font-size: 11px;
  color: #e53935;
  margin-top: 2px;
}

/* Override SearchFields to blend into card style */
.search-field-group :deep(.events-or-culture-input) {
  border: 1px solid #e2e2e2 !important;
  border-radius: 10px !important;
  height: 52px !important;
  padding: 0 14px !important;
  background: #fff;
  display: flex;
  align-items: center;
}

.search-field-group :deep(.events-or-culture-input::before) {
  display: none !important;
}

.search-field-group :deep(.events-or-culture-input input) {
  border: none !important;
  outline: none !important;
  flex: 1;
  min-width: 0;
  font-size: 14px;
  color: #333;
  height: 100%;
  padding: 0 0 0 10px;
}

.search-field-group :deep(.events-or-culture-input img) {
  width: 18px;
  height: 18px;
  opacity: 0.6;
}

/* Full-width submit button */
.search-card-btn {
  width: 100%;
  height: 52px;
  border: none;
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  font-size: 14px;
  font-weight: 600;
  color: #fff;
  cursor: pointer;
  transition: opacity 0.2s;
  margin-top: 4px;
}

.search-card-btn:hover {
  opacity: 0.9;
}

.btn-icon {
  width: 17px;
  height: 17px;
  filter: brightness(0) invert(1);
}

.new_ui_form form {
  position: unset !important;
  transform: unset;
}
</style>
